module.exports = __webpack_public_path__ + "r-v3/img/crown_white.e34adc13.svg";